import { Component,  OnInit, OnDestroy, Output, EventEmitter, Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { LanguageTranslateService } from "src/app/_services/language-translate.service";
import { SubscriptionUtil } from 'src/app/_utilities/subscription';
import { Router } from "@angular/router";
import { ServerRequest } from 'src/app/_models/global.data.model';
import { JobOrdersService } from 'src/app/_services/job-orders.service';
import { ErrorUtil } from 'src/app/_utilities/error';



@Component({
    selector: 'app-fieldex-jo-template',
    templateUrl: './fieldex-jo-template.component.html',
    styleUrls: ['./fieldex-jo-template.component.scss'],
    standalone: false
})
export class FieldexJoTemplateComponent extends SubscriptionUtil implements OnInit, OnDestroy {
  @Output() itemSelector = new EventEmitter();
  @Output() closeView = new EventEmitter();
  @Input() loadFrom?: string;
   @Input() comingFrom: any;
  @Input() checklistRecordId: any = null
  @Input() pmvId: any = null
  @Input() senDataToCreateJO: any = null;
  @Input() displayNewTmplButton?: boolean;

  
  translate: any;
  data: any;

  activeCatId = 'all';
   searchValue: any;
  selectedJOT?: any;
  
    // ====== New list + pagination state (replaces ag-grid) ======
  templates: any[] = [];        // List used by card layout
  pageSize: number = 25;
  startRow: number = 0;                // Offset for server-side pagination
  totalRecord: number = 0;
  loading: boolean = false;            // True when API is in progress
  endOfList: boolean = false;          // True when no more data from server

  // ====== Existing flags ======
  introPageVisible: boolean = false;
  dataPageVisible: boolean = false;
  showNoDataIcon: boolean = false;

  jobOrderTypes: any;
  filter: any = {typeId : null, systemId : null, serviceZoneId : null, isCreation: null};
  
  constructor(
    private router: Router,
    public modalRef : BsModalRef,
    private languageTranslateService: LanguageTranslateService,
    private jobOrdersService : JobOrdersService,
    private errorUtil: ErrorUtil
  ) { 
    super();
  }

  ngOnInit(): void {
      console.log("loadFrom in JO template", this.senDataToCreateJO)
      debugger
    this.getLanguageData();
   // this.recalcCounts();
  }
  //Language
  getLanguageData() {
    this.push(this.languageTranslateService.wordSrc$.subscribe(data => { 
      if(Object.keys(data).length != 0){
        this.translate = data

        this.push(
        this.jobOrdersService.getJobOrderTypeswithCoutnJOT(true).subscribe((res: any) => {
          this.jobOrderTypes = [];
          this.jobOrderTypes.push({ id: 'all', label: 'All templates',jobOrderTmplCount: res?.reduce((acc: number, jot: any) => acc + jot.jobOrderTmplCount, 0) || 0, active: true, order: 0, icon: 'fa-screwdriver-wrench' });
          var jobOrderTypes = res?.filter((jot: any) => jot.active).sort((elementA: any, elementB: any) => {
            if (elementA?.order > elementB?.order) {
              return 1;
            }

            if (elementA?.order < elementB?.order) {
              return -1;
            }

            return 0;
          });
          this.jobOrderTypes = [].concat(this.jobOrderTypes, jobOrderTypes);
          console.log("jobOrderTypes",this.jobOrderTypes)
          
          // Once language is ready, load first page
                 this.resetAndLoad();

        })
      );
      
      }
    }))
    console.log("translate",this.translate)
  }

  push(obs:any) {
    super.push(obs);
  }


  //trackById = (_: number, x: { id: string }) => x.id;

  setCategory(id: string) {
    this.activeCatId = id;
   this.filter.typeId = id === 'all' ? null : id;
   this.resetAndLoad();
  }

  // filteredTemplates(): TemplateItem[] {
  //   const q = this.searchValue.trim().toLowerCase();
  //   const inCat = (t: TemplateItem) => this.activeCatId === 'all' || t.categoryId === this.activeCatId;
  //   const matches = (t: TemplateItem) =>
  //     !q || t.title.toLowerCase().includes(q) || t.desc.toLowerCase().includes(q);
  //   return this.templates.filter(t => inCat(t) && matches(t));
  // }

 // categoryLabel = (id: string) => this.categories.find(c => c.id === id)?.label ?? id;

  // recalcCounts() {
  //   const byCat: Record<string, number> = {};
  //   for (const t of this.templates) byCat[t.categoryId] = (byCat[t.categoryId] ?? 0) + 1;
  //   this.categories = this.categories.map(c =>
  //     c.id === 'all' ? { ...c, count: this.templates.length } : { ...c, count: byCat[c.id] ?? 0 }
  //   );
  // }

  createNewTemplate() {
    this.modalRef.hide();
    setTimeout(() => this.router.navigate(['/dashboard/setup/jobOrder/templates'], { queryParams: { openModal: 'create' }} ), 0);
  }
  nextCreate(){
    this.modalRef.hide();
    // if(this.loadFrom == 'Plan'){
    //   this.itemSelector.emit(this.selectedJOT);
    // }
    // else {
    
    // setTimeout(() => this.router.navigate(['/dashboard/jobOrders/create-v2']), 0);
    // }
  }

  // ================= INFINITE SCROLL CORE =================
  
    /** Reset list and load first page */
    private resetAndLoad(): void {
      this.templates = [];
      this.startRow = 0;
      this.totalRecord = 0;
      this.endOfList = false;
  
      // Reset visibility flags
      this.dataPageVisible = false;
      this.showNoDataIcon = false;
      this.introPageVisible = false;
  
      this.loadtemplates();
    }
    /** Build server request (replaces getRequestParams) */
    private buildServerRequest(): ServerRequest {
      const sortModel = [
        {
          colId: 'fault.name',
          sort: 'asc'
        }
      ];
  
      return {
        startRow: this.startRow,
        pageSize: this.pageSize,
        filterModel: null,
        sortModel
      };
    }
  
    /** Main API call (replaces getServerSideData + setGridData) */
    private loadtemplates(): void {
      if (this.loading || this.endOfList) {
        return;
      }
  
      if (!this.translate) {
        // wait until translations are loaded
        return;
      }
  
      this.loading = true;
  
      const serverRequest = this.buildServerRequest();
      
      this.push(this.jobOrdersService.getAllJobOrderTemplates(this.searchValue, serverRequest,this.filter.typeId,null,null, null, null, "ACTIVE")
          .subscribe(
            (resp: any) => {

              if (resp?.body && Array.isArray(resp.body.data)) {
                resp.body.data.forEach((item: any) => {
                  const jotType = this.jobOrderTypes?.find((type: any) => type.id === item.jobOrderType?.id);
                  if (jotType) {
                    item.joTypeObject = jotType;
                  }
                });
              }

              const body = resp?.body || {};
              const status: string = body.status;
              const items: any[] = body.data || [];
              const total: number = body.total || 0;
  
              this.totalRecord = total;
  
              // Handle special statuses first
              if (status === 'NO_DATA') {
                this.handleNoDataStatus();
              } else if (status === 'SEARCH_NO_RESULTS') {
                this.handleSearchNoResultsStatus();
              } else {
                this.handleSuccessStatus(items);
              }
  
              this.loading = false;
            },
            (err) => {
              this.loading = false;
              this.errorUtil.setErrorMessage(err);
  
              if (!this.templates.length) {
                // only show "no data" icon if there is truly nothing
                this.dataPageVisible = false;
                this.showNoDataIcon = !!this.searchValue;
                this.introPageVisible = !this.searchValue;
              }
            }
          )
      );
    }
  
    /** Infinite scroll handler – call from HTML `(scroll)="onScroll($event)"` */
    onScroll(event: Event): void {
      const target = event.target as HTMLElement;
      const scrollPosition = target.scrollTop + target.clientHeight;
      const scrollHeight = target.scrollHeight;
  
      const threshold = 200; // px before bottom
      if (!this.loading && !this.endOfList && scrollHeight - scrollPosition <= threshold) {
        this.loadtemplates();
      }
    }
  
    // ================= STATUS HANDLERS =================
  
    /** Backend says absolutely no data exists for this asset/plan (first time setup) */
    private handleNoDataStatus(): void {
      // Only show intro page if we have not loaded anything yet
      if (this.startRow === 0) {
        this.templates = [];
        this.endOfList = true;
  
        this.dataPageVisible = false;
        this.showNoDataIcon = false;
        this.introPageVisible = true;
  
     //   this.loadEmptyPage();
      } else {
        // further pages, just mark end of list
        this.endOfList = true;
      }
    }
  
    /** Backend says search has no results */
    private handleSearchNoResultsStatus(): void {
      if (this.startRow === 0) {
        this.templates = [];
        this.endOfList = true;
  
        this.dataPageVisible = false;
        this.showNoDataIcon = true;  // search "no results"
        this.introPageVisible = false;
      } else {
        this.endOfList = true;
      }
    }
  
    /** Normal success – append items & update flags */
    private handleSuccessStatus(items: any[]): void {
      if (!items || !items.length) {
        // No more rows for scrolling
        this.endOfList = true;
  
        if (!this.templates.length) {
          // No initial data at all
          this.dataPageVisible = false;
          this.showNoDataIcon = !!this.searchValue;
          this.introPageVisible = !this.searchValue;
        }
        return;
      }
  
      // If needed, map API model -> view model here.
      // For now, we just append raw items – adjust template to match these fields.
      const mappedItems = items.map((item: any) => {
         // Example: if you want friendly formatted dates, you can do it here
        return {
          ...item,
          };
      });
  
      this.templates = [...this.templates, ...mappedItems];
      console.log("Maintenance Plans:", this.templates);
      //debugger
      // Move cursor for next request
      this.startRow = this.templates.length;
  
      // Visibility flags
      this.dataPageVisible = this.templates.length > 0;
      this.showNoDataIcon = false;
      this.introPageVisible = false;
  
      // If we already have all records, stop scrolling
      if (this.totalRecord && this.templates.length >= this.totalRecord) {
        this.endOfList = true;
      }
    }
  
 selectItem(val: any) {
  this.selectedJOT = val;
  if (this.loadFrom == "Plan" || this.loadFrom == "createBlockTask") {
    this.itemSelector.emit(this.selectedJOT);
  } else {
    // Dynamically build queryParams object
    const queryParams: any = { joTypeId: this.selectedJOT.jobOrderType.id };
    queryParams.templateId = this.selectedJOT.id; // Assuming you want to pass the template ID as well

    // Add checklistId if present
    if (this.checklistRecordId) {
      queryParams.checkListRecordId = this.checklistRecordId;
    }
    if (this.pmvId) {
      queryParams.pmvId = this.pmvId;
    }
    if (this.senDataToCreateJO?.origin == "creareJobOrderFromBryntum") {
      queryParams.createDate = this.senDataToCreateJO.createDate ?? null;
      queryParams.owner = this.senDataToCreateJO.resource?.id;
      queryParams.origin = this.senDataToCreateJO.origin;
      queryParams.endDate = this.senDataToCreateJO?.endDate ?? null;
    }

    //  this.router.navigate(['/dashboard/jobOrders/createStandardJobOrder'], {queryParams});

    const urlTree = this.router.createUrlTree(
      ["/dashboard/jobOrders/createStandardJobOrder"],
      { queryParams },
    );
    const url = this.router.serializeUrl(urlTree);
    if (this.senDataToCreateJO?.origin === "creareJobOrderFromBryntum") {
      window.open(url, "_blank");
      this.closeTable();
    } else {
      this.router.navigate(["/dashboard/jobOrders/createStandardJobOrder"], {
        queryParams,
      });
    }

    // setTimeout(() => this.router.navigate(['/dashboard/jobOrders/createStandardJobOrder']), 0);
  }
  
}

public closeTable() {
  this.closeView.emit(false);
}
/************************************************ Search Data ****************************************/
quickSearch() {
  if(this.searchValue.length > 2 || this.searchValue.length == 0){ 
    this.resetAndLoad()
  }
  
}

}
